import Icon from 'veui/components/Icon'

Icon.register({
  'chevron-up': {
    paths: [
      {
        d: 'M24 13.83L44.59 34.4a2 2 0 002.82-2.82l-22-22a2 2 0 00-2.82 0l-22 22A2 2 0 103.4 34.4L24 13.83z'
      }
    ],
    width: '48',
    height: '48'
  }
})
